// shadcn/evilcharts components import `cn` from `@/lib/utils` (per components.json).
// The admin app's canonical `cn` lives in the shared UI package — re-export it so
// generated components resolve without duplicating the helper.
export { cn } from "@onsand/ui";
